import React from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import { AboutYouSubSteps } from './AboutYouSubSteps';

export const YourNameStep: React.FC<{
  onNext: () => void;
}> = ({ onNext }) => {
  const { goToPreviousStep, canGoBack } = useOnboarding();

  return (
    <AboutYouSubSteps
      subStep="name"
      onNext={onNext}
      onBack={goToPreviousStep}
      canGoBack={canGoBack}
    />
  );
};
